/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Export_ButtonInputs */

const en_video_export_export_button = /** @type {(inputs: Video_Export_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Video`)
};

const fr_video_export_export_button = /** @type {(inputs: Video_Export_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter la video`)
};

const de_video_export_export_button = /** @type {(inputs: Video_Export_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video exportieren`)
};

const it_video_export_export_button = /** @type {(inputs: Video_Export_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esporta video`)
};

const ru_video_export_export_button = /** @type {(inputs: Video_Export_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт видео`)
};

const es_video_export_export_button = /** @type {(inputs: Video_Export_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar vídeo`)
};

const zh_cn2_video_export_export_button = /** @type {(inputs: Video_Export_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出视频`)
};

const ja_video_export_export_button = /** @type {(inputs: Video_Export_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオをエクスポート`)
};

const hi_video_export_export_button = /** @type {(inputs: Video_Export_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो निर्यात करें`)
};

const pt_pt2_video_export_export_button = /** @type {(inputs: Video_Export_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar vídeo`)
};

/**
* | output |
* | --- |
* | "Export Video" |
*
* @param {Video_Export_Export_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_export_button = /** @type {((inputs?: Video_Export_Export_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Export_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_export_button(inputs)
	if (locale === "de") return de_video_export_export_button(inputs)
	if (locale === "it") return it_video_export_export_button(inputs)
	if (locale === "ru") return ru_video_export_export_button(inputs)
	if (locale === "es") return es_video_export_export_button(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_export_button(inputs)
	if (locale === "ja") return ja_video_export_export_button(inputs)
	if (locale === "hi") return hi_video_export_export_button(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_export_button(inputs)
	return en_video_export_export_button(inputs)
});